export const version = "abi/5.6.3";
//# sourceMappingURL=_version.js.map